import "@/App.css";
import { ThemeProvider } from "@/context/ThemeContext";
import Playground from "@/pages/Playground";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <ThemeProvider>
      <div className="App">
        <Playground />
        <Toaster position="bottom-right" />
      </div>
    </ThemeProvider>
  );
}

export default App;
